import { AxiosResponse, AxiosError } from 'axios'
import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface CreateMedicRequestProps {
  treatmentValidity?: {
    ourEvaluation?: boolean;
    medicalRequest?: string;
    cid?: string | number;
    professionalCrmCode?: string | number
    professionalCrmUf?: string
  }
  isCareplus?: boolean
  planCode?: string
}

const createMedicRequest = ({
  treatmentValidity = {},
  isCareplus = false,
  planCode
}: CreateMedicRequestProps): Promise<AxiosResponse | AxiosError> => {
  return new Promise((resolve, reject) => {

    const endpoint = isCareplus ?
      `${apiEndpoints.VALIDITIES}care-plus/` :
      apiEndpoints.PATIENTS_MEDICAL_REQUEST

    const treatment_validity = {
      ...(treatmentValidity.ourEvaluation && { our_evaluation: treatmentValidity.ourEvaluation }),
      ...(treatmentValidity.medicalRequest && { medical_request: treatmentValidity.medicalRequest }),
      ...(treatmentValidity.cid && { cid: treatmentValidity.cid }),
      ...(treatmentValidity.professionalCrmCode && { professional_crm_code: treatmentValidity.professionalCrmCode }),
      ...(treatmentValidity.professionalCrmUf && { professional_crm_uf: treatmentValidity.professionalCrmUf }),
    }

    const payload =  isCareplus ? {
      treatment_validity: {
        ...treatment_validity
      }
    } : {
      ...treatment_validity
    } 

    const params = {
      ...(planCode && { plan_code: planCode }),
    }

    axios.post(endpoint, payload, { params })
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
}

export {
  createMedicRequest
}